import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import Member from './Member'
import Brand from './Brand'
import { PageNotFound } from 'components/Shared/ErrorPage'

const Team: React.FC<any> = () => {
    return (
        <Switch>
            <Route path={'/team'} exact render={() => <Redirect to="/teams" />} />
            <Route
                path="/team/:uuid"
                exact
                render={props => <Redirect to={`/team/${props.match.params.uuid}/members`} />}
            />
            <Route path="/team/:uuid/members" exact component={Member} />
            <Route path="/team/:uuid/brands" exact component={Brand} />
            <Route path="*" component={PageNotFound} />
        </Switch>
    )
}

export default Team
